import React, { useState } from "react";
import useForm from "../hooks/useForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import ForgotPasswordModal from "./ForgotPasswordModal";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

export default function Login({ setShowLogin, user, setUserInfo }) {
  const {
    handleChange,
    loginData,
    handleSubmit,
    errors,
    loginError,
    handleGoogleSignIn,
  } = useForm(user, setUserInfo);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return !isModalOpen ? (
    <div className="z-20 md:w-2/6 py-20 px-10 mx-10 my-10 md:my-20 bg-opacity-90 rounded-md border bg-white">
      <h1 className="font-semibold text-3xl text-ambhosOrange mb-5">Login</h1>
      <hr className="mb-10" />
      <form
        className="flex flex-col space-y-3"
        onSubmit={(e) => handleSubmit(e, "login")}
      >
        {loginError && (
          <p className="px-2 py-1 bg-red-100 text-red-500">
            <FontAwesomeIcon icon={faExclamationCircle} /> {loginError}
          </p>
        )}
        <div className="flex flex-col">
          <input
            type="email"
            name="email"
            placeholder="email address"
            value={loginData.email}
            onChange={(e) => handleChange(e, "login")}
            className="border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
          />
          {errors.email && (
            <small className="text-red-500 mt-0">{errors.email}</small>
          )}
        </div>
        <div className="flex flex-col">
          <div className="bg-white flex justify-between items-center border-2 border-gray-500 rounded-md">
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              placeholder="password"
              value={loginData.password}
              onChange={(e) => handleChange(e, "login")}
              className="w-full rounded-md py-2 px-2 outline-none"
            />
            {passwordVisible ? (
              <FontAwesomeIcon
                onClick={() => setPasswordVisible(false)}
                className="text-lg px-2 cursor-pointer"
                icon={faEyeSlash}
              />
            ) : (
              <FontAwesomeIcon
                onClick={() => setPasswordVisible(true)}
                className="text-lg px-2 cursor-pointer"
                icon={faEye}
              />
            )}
          </div>
          {errors.password && (
            <small className="text-red-500 mt-0">{errors.password}</small>
          )}
        </div>
        <button
          className="rounded-md py-2 px-2 text-lg bg-ambhosOrange text-white"
          type="submit"
        >
          Login
        </button>
        <button
          onClick={openModal}
          className="text-end cursor-pointer hover:text-ambhosOrange"
        >
          Forgot Password?
        </button>
      </form>
      <button
        className="flex items-center w-full mt-4 rounded-sm font-semibold text-white border border-blue-500 bg-blue-500"
        onClick={handleGoogleSignIn}
      >
        <div className="w-14 flex justify-center bg-white p-3 rounded-sm">
          <img
            src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/google.png"
            className="mr-0 w-5 h-5"
            alt=""
          />
        </div>
        <div className="w-full flex justify-center">
          <p>Sign in with Google</p>
        </div>
      </button>
      <hr className="mt-2" />
      <p className="mt-5">New to BrioCart?</p>
      <button
        className="w-full mt-2 rounded-md py-2 px-2 text-lg text-ambhosOrange border-2 border-ambhosOrange"
        onClick={() => setShowLogin(false)}
      >
        Create Account
      </button>
    </div>
  ) : (
    <ForgotPasswordModal isOpen={isModalOpen} onClose={closeModal} />
  );
}
